<div class="lg:ps-14 lg:pt-5 lg:pb-5 lg:pe-7 ps-4 pt-4 pb-4 pe-4 border-b border-[#EBEDF3] bg-[#FBFBFC]">

  <div class="flex justify-end">
    <button [disabled]="loading" (click)="cancel()" matTooltip="Close"
      class="size-5 rounded-md flex justify-center items-center outline-0 cursor-pointer group" [ngClass]="{
      'hover:bg-black': !loading
    }">
      <!-- Gray cross (default) -->
      <img src="../../../../../../assets/images/icons/global/popup-cross.svg" class="block group-hover:hidden"
        alt="gray cross" height="10" width="10" />

      <!-- White cross (on hover) -->
      <img src="../../../../../../assets/images/icons/global/popup-cross-white.svg" class="hidden group-hover:block"
        alt="white cross" height="10" width="10" />
    </button>
  </div>

  <div class="lg:pe-6 pe-0">

    <div class="flex lg:flex-row flex-col justify-between items-end lg:mb-6 mb-0">
      <div class="w-full">
        <div class="border border-[#D9D9D9] rounded-md px-2.5 py-1.5 mb-1.5 inline-flex">
          <p class="text-[#1A1A1A] font-semibold text-xs leading-4 text-nowrap">{{selectedTicketNo}}</p>
        </div>
        <h1 class="font-medium md:text-2xl text-lg leading-normal text-[#15191E] lg:mb-3 mb-1">
          {{ticket?.problemLookup?.name}}</h1>
        <div class="w-full">
          <div class="flex lg:gap-0 gap-3 font-medium text-xs leading-normal text-[#6B7080]">
            <div class="flex lg:flex-row flex-col">
              <span>Created: </span>
              <span class="text-[#15191E] ml-1"> {{ticket?.entryDate | date: 'MMMM d, y, HH:mm'}}</span>
            </div>
            <div class="flex lg:flex-row flex-col">
              <span
                class="lg:inline-block hidden before:mx-2.5 before:content-[''] before:inline-block before:size-1 before:rounded-full before:bg-[#A9ABB04D] text-center"></span>
              <span>Last Activity: </span>
              <span class="text-[#15191E] me-2.5 ml-1"> {{ticket?.updatedOn | date: 'MMMM d, y, HH:mm'}}</span>
            </div>
          </div>

        </div>
      </div>
      <div class="flex gap-2.5 lg:w-auto w-full lg:mt-0 mt-2">
        <div
          class="border-2 border-dashed border-[#C4CADA] rounded-md xl:w-32 lg:px-5 py-3 flex justify-center items-center flex-col lg:flex-auto flex-1">
          <p class="font-medium lg:text-base text-sm leading-3.5 text-[#15191E] mb-0.5">
            {{getTotalEstimatedHours(ticket)}}</p>
          <p class="font-medium lg:text-xs text-[10px] leading-4 text-[#60646C]">Est Hours</p>
        </div>
        <div
          class="border-2 border-dashed border-[#C4CADA] rounded-md xl:w-32 lg:px-5 py-3 flex justify-center items-center flex-col lg:flex-auto flex-1">
          <p class="font-medium lg:text-base text-sm leading-3.5 text-[#15191E] mb-0.5">
            ${{getTotalEstimatedLaborCost(ticket)}}</p>
          <p class="font-medium lg:text-xs text-[10px] leading-4 text-[#60646C]">Est Cost</p>
        </div>
        <div
          class="border-2 border-dashed border-[#C4CADA] rounded-md xl:w-32 lg:px-5 py-3 flex justify-center items-center flex-col lg:flex-auto flex-1 bg-[#FEFCE8]">
          <p class="font-medium lg:text-base text-sm leading-3.5 text-[#15191E] mb-0.5">{{getTotalWorkerHours(ticket)}}
          </p>
          <p class="font-medium lg:text-xs text-[10px] leading-4 text-[#60646C]">Actual Hours</p>
        </div>
        <div
          class="border-2 border-dashed border-[#C4CADA] rounded-md xl:w-32 lg:px-5 py-3 flex justify-center items-center flex-col lg:flex-auto flex-1 bg-[#FEF2F2] ">
          <p class="font-medium lg:text-base text-sm leading-3.5 text-[#15191E] mb-0.5">
            ${{getTotalRegularLaborCost(ticket) | number:'1.2-2'}}</p>
          <p class="font-medium lg:text-xs text-[10px] leading-4 text-[#60646C]">Actual Cost</p>
        </div>
      </div>
    </div>


    <div class="flex lg:flex-row flex-col justify-between lg:items-center items-start">

      <div class="flex gap-4 lg:py-0 py-2 items-center">
        <ng-container *ngIf="getLatestChangeStatus(this.ticket)?.assignedUser as primaryUser">

          <app-avatar
            [userList]="[{ displayName: primaryUser?.fullName, pic: primaryUser?.pic}]"
            size="xl"
            [charLength]="2">
          </app-avatar>
          <!-- vertical divider start -->
          <div class="bg-[#EBEDF3] h-[29px] w-[1.5px]"></div>
          <!-- vertical divider start -->
        </ng-container>


        <div class="flex -space-x-1.5">
          <app-avatar
            [userList]="ticketLaborUserList(this.ticket)"
            size="xl"
            [charLength]="2"
            [showRemaining]="false">
          </app-avatar>

        </div>
        <button
          *ngIf="laborList.length > 1"
          type="button"
          class="size-3.5 rounded-full flex justify-center items-center hover:bg-gray-200 cursor-pointer"
          (click)="toggleDropdown('member-remove', $event)">
          <img src="./assets/images/icons/arrows/arrow-down.svg" class="size-2" alt="">
          <div class="relative cursor-default">
            <button
              type="button"
              class="custom-popup -left-2 top-5 w-screen max-w-[320px] !py-0 max-h-[300px] overflow-y-auto text-left"
              [ngClass]="isDropdownVisible('member-remove') ? 'popup-active' : 'popup-inactive'"
              (click)="onDivClick($event)">
              <ul class="text-sm text-[#15191E] font-medium leading-4 text-start divide-y divide-gray-200">
                <li class="px-4 py-3 flex gap-1 justify-between items-center"
                  *ngFor="let item of laborList; let i = index">
                  <div class="flex items-center gap-2">
                    <app-avatar
                      [userList]="[{ displayName: item?.workerName, pic: item?.workerPic}]"
                      [size]="'xl'" [showTooltip]="false"></app-avatar>
                    <span>{{item?.workerName}}</span>
                  </div>
                  <div *ngIf="!isCompleted" class="flex items-center gap-1">

                    <!-- Flag button to mark is Main assignee -->
                    @if(checkParimaryAssignee(item.workerId) && changePrimaryAssignee === 0){
                    <button *ngIf="changeAssigneeWrite"
                      class="size-6 flex items-center justify-center rounded transition cursor-pointer hover:bg-[#F8F8FA]"
                      matTooltip="Primary Assignee" (click)="onChangePrimaryAssignee()">
                      <img src="../../../../../../assets/images/icons/global/flag-red-fill.svg"
                        alt="flag-red-outline" />
                    </button>

                    }
                    @else{
                    @if(changePrimaryAssignee === 1){
                    <button
                      class="size-6 flex items-center justify-center rounded transition cursor-pointer hover:bg-[#F8F8FA]"
                      matTooltip="Set Primary Assignee" (click)="onSubmitPrimaryAssignee(item?.workerId)">
                      <img src="../../../../../../assets/images/icons/global/flag-red-outline.svg"
                        alt="flag-red-outline" />
                    </button>

                    }
                    }
                    <button *ngIf="checkUserPermissions('write:changeworker')"
                      [style.pointer-events]="checkParimaryAssignee(item.workerId) ? 'none' : 'auto'"
                      [style.opacity]="checkParimaryAssignee(item.workerId) ? '0.4' : '1'"
                      class="size-6 flex items-center justify-center rounded transition cursor-pointer hover:bg-[#F8F8FA]"
                      matTooltip="Delete" (click)="onRemoveSecondary(item.workerId, item?.workerName)">
                      <img src="../../../../../../assets/images/icons/global/archive.svg" alt="table-edit" />
                    </button>
                  </div>
                </li>
              </ul>
            </button>
          </div>
        </button>
        <!-- vertical divider start -->
        <div *ngIf="laborList.length>1" class="bg-[#EBEDF3] h-[29px] w-[1.5px]"></div>
        <!-- vertical divider start -->
        <ng-container
          *ngIf="(checkUserPermissions('write:changeworker')) && isCompleted === false">
          <span matTooltip="Add Team Member"
            class="flex items-center justify-center hover:z-10 relative shrink-0 rounded-full bg-white ring-1 ring-white border border-dashed border-[#D6D7DC] size-8 cursor-pointer"
            (click)="AddTeamMemberAndHour()"
            (keydown.enter)="AddTeamMemberAndHour()"
            role="button"
            tabindex="0">
            <img src="../../../../../../assets/images/icons/ticket-detail/add-profile.svg" alt="">
          </span>
        </ng-container>
      </div>
      <div class="flex lg:flex-row flex-col gap-2 lg:w-auto w-full">

        <!--Ticket Priority Dropdown Start-->
        <div [style.pointer-events]="isCompleted || !changePriorityWrite? 'none' : 'auto'"
          [style.opacity]="isCompleted || !changePriorityWrite? '0.6' : '1'">
          <ng-select [items]="priorityList" bindLabel="name" [clearable]="false" [searchable]="false"
            [(ngModel)]="selectedPriorityId" placeholder="priority" (change)="onSubmitPriority($event)"
            class="lg:w-[150px] w-full border border-[#E3E6EE] rounded shadow-none text-xs leading-6 font-medium text-[#15191E] focus:shadow-none">
            <!-- Customize how options are displayed -->
            <ng-template ng-option-tmp let-item="item">
              <div class="flex items-center gap-2">
                <svg width="12" height="12" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.21899 1.75V14.25" [attr.stroke]="tileColor(item)" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M3.21899 3H10.219C11.9065 3 12.2815 3.9375 11.094 5.125L10.344 5.875C9.84399 6.375 9.84399 7.1875 10.344 7.625L11.094 8.375C12.2815 9.5625 11.844 10.5 10.219 10.5H3.21899"
                    [attr.stroke]="tileColor(item)" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                <span class="w-[80%] whitespace-nowrap overflow-ellipsis overflow-hidden block box-border" [style.color]="tileColor(item)">{{ item.name }}</span>
              </div>
            </ng-template>
            <!-- Customize how selected value is displayed -->
            <ng-template ng-label-tmp let-item="item">
              <span class="flex items-center gap-2">
                <svg width="12" height="12" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.21899 1.75V14.25" [attr.stroke]="tileColor(item)" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M3.21899 3H10.219C11.9065 3 12.2815 3.9375 11.094 5.125L10.344 5.875C9.84399 6.375 9.84399 7.1875 10.344 7.625L11.094 8.375C12.2815 9.5625 11.844 10.5 10.219 10.5H3.21899"
                    [attr.stroke]="tileColor(item)" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                <span [style.color]="tileColor(item)">{{ item.name }}</span>
              </span>
            </ng-template>

          </ng-select>
        </div>
        <!--Ticket Priority Dropdown Start-->
        <div class="flex gap-2">
          <div class="lg:flex-auto flex-1">
            <button [style.pointer-events]="isCompleted || !recurringTicketWrite? 'none' : 'auto'" [style.opacity]="isCompleted || !recurringTicketWrite? '0.6' : '1'"
              class="font-medium text-xs text-[#15191E] leading-3 border border-[#E3E6EE] rounded-md px-2 py-2.5 cursor-pointer bg-white flex gap-2 items-center text-nowrap lg:w-auto w-full"
              (click)="ticketSchedule()">
              <img src="./assets/images/icons/ticket-detail/recurrence-schedule.svg" alt="">
              <span class="">Recurrence Schedule</span>
            </button>
          </div>


          <div class="relative" [style.pointer-events]="isCompleted || !ChangeTicketPlanDateWrite? 'none' : 'auto'"
            [style.opacity]="isCompleted || !ChangeTicketPlanDateWrite? '0.6' : '1'">
            <input type="text" [ngModel]="planStartEndDate" ngxDaterangepickerMd readonly [matTooltip]="'Planed Start Date - End Date'"
              placeHolder="Start Date, End Date and Time" class="calendar-input font-medium text-xs text-[#15191E] leading-3 border border-[#E3E6EE] rounded-md px-2 py-2.5 pl-9 pr-3 cursor-pointer bg-white w-[270px] bg-no-repeat bg-[length:16px] bg-[position:10px_center]"
              [timePicker]="true" [timePickerSeconds]="false"
              [showCancel]="true" [timePicker24Hour]="false" [showCustomRangeLabel]="false"
              [locale]="{format: 'MM/DD/YYYY HH:mm', firstDay: 0}" (change)="onSubmitPlanDate($event)" />
          </div>

          <div class="relative" [style.pointer-events]="isCompleted || !changeTicketDueDateWrite? 'none' : 'auto'"
            [style.opacity]="isCompleted || !changeTicketDueDateWrite? '0.6' : '1'">
            <input type="text" ngxDaterangepickerMd [singleDatePicker]="true" [multiple]="true" [ngModel]="dueDate"
              [timePicker]="true" [timePicker24Hour]="true" placeHolder="Add Due Date"  [matTooltip]="'Ticket Due Date'"
              readonly class="calendar-input font-medium text-xs text-[#15191E] leading-3 border border-[#E3E6EE] rounded-md px-2 py-2.5 pl-9 pr-3 cursor-pointer bg-white w-[158px] bg-no-repeat bg-[length:16px] bg-[position:10px_center]"
              [locale]="dateLocale"
              (change)="onSubmitDueDate($event)" />
          </div>
        </div>

      </div>

    </div>

  </div>

  <ul
    class="flex overflow-x-auto whitespace-nowrap gap-1 font-medium text-sm leading-[18px] text-[#141414] lg:mt-7 mt-3">

    <li class="min-w-max">
      <a class="flex gap-1.5 items-center py-2 px-3 rounded-md cursor-pointer"
        [ngClass]="activeClass('DetailsActivities')" (click)="setTab('DetailsActivities')"
        (keydown.space)="setTab('DetailsActivities')"
        role="button"
        tabindex="0">
        <img src="../../../../../../assets/images/icons/ticket-detail/details&activities-black.svg" class="size-4"
          alt="" [ngClass]="activeTab === 'DetailsActivities' ? 'hidden' : 'block'">
        <img src="../../../../../../assets/images/icons/ticket-detail/details&activities.svg" class="size-4" alt=""
          [ngClass]="activeTab !== 'DetailsActivities' ? 'hidden' : 'block'">
        Details & Activities
      </a>
    </li>

    <li *ngIf="AddHoursRead || AddHoursWrite" class="min-w-max">
      <a class="flex gap-1.5 items-center py-2 px-3 rounded-md cursor-pointer" [ngClass]="activeClass('AddHours')"
        (click)="setTab('AddHours')"
        (keydown.space)="setTab('AddHours')"
        role="button"
        tabindex="0">
        <img src="../../../../../../assets/images/icons/ticket-detail/addHours-black.svg" class="size-4" alt=""
          [ngClass]="activeTab === 'AddHours' ? 'hidden' : 'block'">
        <img src="../../../../../../assets/images/icons/ticket-detail/addHours-hover.svg" class="size-4" alt=""
          [ngClass]="activeTab !== 'AddHours' ? 'hidden' : 'block'">
        Add Hours
      </a>
    </li>

    <li *ngIf="TeamHoursRead || TeamHoursWrite" class="min-w-max">
      <a class="flex gap-1.5 items-center py-2 px-3 rounded-md cursor-pointer" [ngClass]="activeClass('TeamHours')"
        (click)="setTab('TeamHours')"
        (keydown.space)="setTab('TeamHours')"
        role="button"
        tabindex="0">
        <img src="../../../../../../assets/images/icons/ticket-detail/teamHours-black.svg" class="size-4" alt=""
          [ngClass]="activeTab === 'TeamHours' ? 'hidden' : 'block'">
        <img src="../../../../../../assets/images/icons/ticket-detail/teamHours-hover.svg" class="size-4" alt=""
          [ngClass]="activeTab !== 'TeamHours' ? 'hidden' : 'block'">
        Team Hours
      </a>
    </li>

    <li *ngIf="TicketLocationRead || TicketLocationWrite" class="min-w-max">
      <a class="flex gap-1.5 items-center py-2 px-3 rounded-md cursor-pointer" [ngClass]="activeClass('Location')"
        (click)="setTab('Location')"
        (keydown.space)="setTab('Location')"
        role="button"
        tabindex="0">
        <img src="../../../../../../assets/images/icons/ticket-detail/location-black.svg" class="size-4" alt=""
          [ngClass]="activeTab === 'Location' ? 'hidden' : 'block'">
        <img src="../../../../../../assets/images/icons/ticket-detail/location-hover.svg" class="size-4" alt=""
          [ngClass]="activeTab !== 'Location' ? 'hidden' : 'block'">
        Location
      </a>
    </li>

    <li *ngIf="TicketEquipmentRead || TicketEquipmentWrite" class="min-w-max">
      <a class="flex gap-1.5 items-center py-2 px-3 rounded-md cursor-pointer" [ngClass]="activeClass('Equipment')"
        (click)="setTab('Equipment')"
        (keydown.space)="setTab('Equipment')"
        role="button"
        tabindex="0">
        <img src="../../../../../../assets/images/icons/ticket-detail/equipment-black.svg" class="size-4" alt=""
          [ngClass]="activeTab === 'Equipment' ? 'hidden' : 'block'">
        <img src="../../../../../../assets/images/icons/ticket-detail/equipment-hover.svg" class="size-4" alt=""
          [ngClass]="activeTab !== 'Equipment' ? 'hidden' : 'block'">
        Equipment
      </a>
    </li>

    <li *ngIf="TicketAttachmentsRead || TicketAttachmentsWrite" class="min-w-max">
      <a class="flex gap-1.5 items-center py-2 px-3 rounded-md cursor-pointer" [ngClass]="activeClass('Attachments')"
        (click)="setTab('Attachments')"
        (keydown.space)="setTab('Attachments')"
        role="button"
        tabindex="0">
        <img src="../../../../../../assets/images/icons/ticket-detail/attachement-black.svg" class="size-4" alt=""
          [ngClass]="activeTab === 'Attachments' ? 'hidden' : 'block'">
        <img src="../../../../../../assets/images/icons/ticket-detail/attachement-hover.svg" class="size-4" alt=""
          [ngClass]="activeTab !== 'Attachments' ? 'hidden' : 'block'">
        Attachments
      </a>
    </li>

  </ul>

</div>


<mat-dialog-content class="mat-typography" [style.pointer-events]="isLoadingTabs? 'none' : 'auto'"
          [style.opacity]="isLoadingTabs? '0.6' : '1'"
  [ngClass]="activeTab ==='Location' ? '!p-0' : 'lg:!pt-7 lg:!pb-2 lg:!px-10 !px-4 !pt-4 !pb-4' ">
  @if (activeTab === 'DetailsActivities'){
  <h2 class="font-medium leading-[26px] text-[18px] text-[#15191E] mb-2">Description</h2>
  <p class="lg:text-sm text-xs font-normal text-[#60646C] break-all">
    {{getTicketDescription()}}
  </p>
  <ng-container *ngIf="NotesAndDetailsRead || NotesAndDetailsWrite" >
    <h3 class="font-medium leading-[26px] text-[18px] text-[#15191E] lg:mt-7 mt-2 mb-2">Notes and Status</h3>
    <app-notes [noteModuleCode]="LookupModuleCode" [objectID]="this.selectedTicketId" (lastNote)="$event"
      [isSaveButton]="true" [assigneeId]="assignedUserId" dropdownPositionClass='dropDown_position'
      [isManager]="isManager" (lastNote)="handleLastNoteEvent($event)" [latestChangeStatus]="latestChangeStatus"
      [isRefreshFromParent]="refreshNotes" [parentTimeZone]="timeZone" [notesWithStatus]="true" [isDisplayNotes]="true"
      [isDisplayStatus]="true" [selectedCurrentStatusId]="ticket?.currentChangeStatusId"
      (isChangeAvailable)="checkChangeAnything($event)"
      [isCompleted]="isCompleted"
      (isTicketCompleted)="isTicketCompleted($event)"
      [isTextRequired]="false"
      [lookupCategoryCode]="lookupCategoryCode"
      [ChangeTicketStatusWrite]="changeTicketStatusWrite">
    </app-notes>
  </ng-container>
  } @else if (activeTab === 'AddHours') {
  <app-add-hour [ticketId]="selectedTicketId" [primaryAssigneeId]="assignedUserId"
    (updateTicket)="updateTicket()" [isCompleted]="isCompleted"></app-add-hour>
  }@else if (activeTab === 'TeamHours') {
  <app-team-hour [ticketId]="selectedTicketId" [getTicket]="ticket" (updateTicket)="updateTicket()"
    (isChangeAnyThing)="checkChangeAnything($event)" [isCompleted]="isCompleted"></app-team-hour>
  }@else if (activeTab === 'Location') {
  <app-location [ticketId]="selectedTicketId" [ticketLat]="ticketLat" [ticketLng]="ticketLng"
    (updateTicket)="updateTicket()" [ticket]="ticket"
    (isChangeAnyThing)="checkChangeAnything($event)" [isCompleted]="isCompleted" [TicketLocationWrite]="TicketLocationWrite"></app-location>
  }@else if (activeTab === 'Equipment') {
  <app-equipment></app-equipment>
  }@else if (activeTab === 'Attachments') {
  <app-attachment [objectID]="selectedTicketId" [noteModuleCode]="'TKT'" [parentTimeZone]="timeZone"
    (isChangeAnyThing)="checkChangeAnything($event)" [isCompleted]="isCompleted" [TicketAttachmentsWrite]="TicketAttachmentsWrite"></app-attachment>
  }
</mat-dialog-content>
